const USER_APPLICATIONS = {
  UNIFIED_APPLICATION: "unified",
  PRM_APPLICATION: "prmanager",
  REVIEW_APPLICATION: "rep",
};

export { USER_APPLICATIONS };
